export const DEFAULT_MAP_NAMESPACE = 'TM_IAD.AlertTopPanelDetails';
